import Vue from "vue";
import http from "../../shared/http"

const components = {
    state: {
        apps: null,
        publicApps: null,
        forgeApps: null,
        allForgeApps: null,
    },
    actions: {
        fetchApps({commit, state}) {
            return new Promise((resolve, reject) => {
                if (state.apps) {
                    resolve(state.apps)
                    return
                }

                http.get("/v3/system/gateway/app-service/app/workspace").then((resp) => {
                    if (resp === undefined) {
                        reject(new Error("Unexpected error"));
                    }

                    commit('SET_APPS', resp.data || [])
                    resolve(resp.data)
                }).catch((err) => {
                    reject(err)
                })
            })
        },

        fetchAllApps() {
            return new Promise((resolve, reject) => {
                http.get("/v3/system/gateway/app-service/all").then((resp) => {
                    if (resp === undefined) {
                        reject(new Error("Unexpected error"));
                    }

                    resolve(resp.data)
                }).catch((err) => {
                    reject(err)
                })
            })
        },

        fetchPublicApps({commit, state}) {
            return new Promise((resolve, reject) => {

                if (state.publicApps) {
                    resolve(state.publicApps)
                    return
                }

                http.get("/v3/system/gateway/app-service/public-app/all").then((resp) => {
                    if (resp === undefined) {
                        reject(new Error("Unexpected error"));
                    }

                    commit('SET_PUBLIC_APPS', resp.data || [])
                    resolve(resp.data)
                }).catch((err) => {
                    reject(err)
                })
            })
        },

        refreshForgeApps({commit, dispatch}) {
            commit('SET_FORGE_APPS', null)
            return dispatch('fetchForgeAppsForWorkspace')
        },

        fetchForgeAppsForWorkspace({commit, state}) {
            return new Promise((resolve, reject) => {

                console.log("fetchForge Apps")

                if (state.forgeApps) {
                    resolve(state.forgeApps)
                    return
                }

                http.get("/luma/appservice/v1/forge/workspace").then((resp) => {
                    if (resp === undefined) {
                        reject(new Error("Unexpected error"));
                    }

                    commit('SET_FORGE_APPS', resp.data || [])

                    resolve(resp.data)
                }).catch((err) => {
                    reject(err)
                })
            })
        },

        fetchAllForgeApps({commit, state}) {
            return new Promise((resolve, reject) => {
                if (state.allForgeApps) {
                    resolve(state.allForgeApps)
                    return
                }

                http.get("/luma/appservice/v1/forge").then(resp => {
                    resolve(resp.data)
                    commit('SET_ALL_FORGE_APPS', resp.data || [])
                }).catch(err => {
                    reject(err)
                })

            })
        }
    },
    mutations: {
       SET_APPS(state, payload) {
           state.apps = payload
       },

       REMOVE_APP(state, uuid) {
           Vue.set(state, 'apps', state.apps.filter(a => a.uuid != uuid))
       },

       SET_PUBLIC_APPS(state, payload) {
           state.publicApps = payload
       },

       REMOVE_PUBLIC_APP(state, uuid) {
           Vue.set(state, 'publicApps', state.publicApps.filter(a => a.uuid != uuid))
       },

       SET_FORGE_APPS(state, apps) {
            state.forgeApps = apps
       },

       SET_ALL_FORGE_APPS(state, apps) {
            state.allForgeApps = apps
       }
    },
    getters: {
        getApps(state, getters) {
            const currentEnv = getters.getCurrentEnv
            const apps = state.apps || []

            return apps.filter(c => {
                if (c.dev_version == '') {
                    return false
                }

                if (currentEnv == 'dev')
                    return c.dev_version != ''

                if (currentEnv == 'live')
                    return c.public_version != ''
            })
        },

        getPublicApps(state) {
            return state.publicApps
        },

        getForgeApps(state, getters) {
            const currentEnv = getters.getCurrentEnv
            const apps = state.forgeApps || []

            return apps.filter(c => {
                if (c.dev_version == '') {
                    return false
                }

                if (currentEnv == 'dev')
                    return c.dev_version != ''

                if (currentEnv == 'live')
                    return c.public_version != ''
            })
        },

        getAllForgeApps(state) {
            return state.allForgeApps || []
        }
    }
  }

export default components;